import { ReactNode } from "react";

import PageWrapper from "components/PageWrapper";
import PageInfoHeader from "ds/components/PageInfoHeader";

type RuntimeSecurityPageLayoutProps = {
  children: ReactNode;
};

const RuntimeSecurityPageLayout = ({ children }: RuntimeSecurityPageLayoutProps) => {
  return (
    <>
      <PageInfoHeader title="Runtime Security" />
      <PageWrapper>{children}</PageWrapper>
    </>
  );
};

export default RuntimeSecurityPageLayout;
